module.exports = __webpack_public_path__ + "img/transaction-success.927e6713.png";